/* eslint-disable */
import { useEffect, useState } from 'react'
import ShowAnswer from './ShowAnswer'
import { Button, Input } from '@chakra-ui/react'

function Answer(props) {
  const {
    countryData,
    score,
    setScore,
    countriesGuessed,
    setCountriesGuessed,
    currentQuestion,
    setCurrentQuestion,
    numberOfLettersGuessed,
    setNumberOfLettersGuessed,
    showAnswer,
    setShowAnswer,
    isCorrect,
    setIsCorrect,
    setShowCurrency
  } = props;
  const [guesses, setGuesses] = useState([])
  const [guess, setGuess] = useState('')
  const [correctGuesses, setCorrectGuesses] = useState(countryData.nativeName)
  const [showTryAgain, setShowTryAgain] = useState(false)

  const checkIfCorrectGuess = () => {
    const correctGuessesLowerCase = correctGuesses.map(cg => cg.toLowerCase())
    const _isCorrect =
      correctGuessesLowerCase.find((possibleGuess) => guess.trim().toLowerCase() === possibleGuess)
    if (_isCorrect) {
      setIsCorrect(true)
      setScore(score + 1)
      setCountriesGuessed(countriesGuessed + 1)
    } else {
      setGuess('')
      setShowTryAgain(true)
      const timer = setTimeout(() => {
        setShowTryAgain(false)
      }, 5000)
      return () => clearTimeout(timer)
    }
  }

  const goToNextCountry = () => {
    setNumberOfLettersGuessed(0)
    setIsCorrect(false)
    setShowAnswer(false)
    setGuesses([])
    setGuess('')
    setCurrentQuestion(currentQuestion + 1)
    setShowCurrency(false)
  }

  const handleGivingUp = () => {
    setCountriesGuessed(countriesGuessed + 1)
    setShowAnswer(true)
  }

  const handleGuess = () => {
    const updatedGuesses = guesses.concat(guess.trim())
    setGuesses(updatedGuesses)
    if (updatedGuesses.length >= 5) {
      handleGivingUp()
    } else {
      checkIfCorrectGuess()
    }
  }

  const getGuessLetterAmount = () => {
    let guesses = 2
    const wordCount = countryData.name.common.split(' ').length
    if (wordCount > 1) {
      guesses = (wordCount * 2) - 1
    }
    return guesses
  }

  useEffect(() => {
    const altSpellings = countryData.altSpellings
    if (altSpellings && altSpellings.length) {
      const updatedCorrectGuesses = [...countryData.nativeName, ...altSpellings]
      setCorrectGuesses(updatedCorrectGuesses)
    }
  }, [currentQuestion])

  return (
    <>
      {!isCorrect && guesses.length && !showAnswer ?
        <div className="Guesses-container">
          <p className="Guesses">Guesses: {guesses.join(', ')}<br />for {guesses.length} total.</p>
          {showTryAgain ? <p style={{ color: 'red', margin: 0, fontWeight: 800 }}>Try again!</p> : null}
        </div>
        : null
      }

      {!isCorrect && !showAnswer ?
        <>
          <p className="Guess-label"><label>🌏 Know the country?</label></p>
          <Input onChange={e => setGuess(e.target.value)} value={guess} placeholder="Enter a country" htmlSize={28} width="auto" variant="filled" />
          <Button isDisabled={guess === ''} onClick={() => handleGuess()}>
            Submit Guess
          </Button>

          <div className="Button-container">
            {numberOfLettersGuessed <= getGuessLetterAmount() ?
              <Button
                className="Button-padding-right"
                onClick={() => setNumberOfLettersGuessed(numberOfLettersGuessed + 1)}
              >
                Show letter
              </Button>
              : null}
            <Button onClick={() => handleGivingUp()}>Just tell me</Button>
          </div>
        </>
        : null}

      {isCorrect ?
        <ShowAnswer
          isCorrect={isCorrect}
          correctGuesses={countryData.nativeName}
          goToNextCountry={goToNextCountry}
          countryName={countryData.name.common}
          size={countryData.area}
          guesses={guesses}
        />
        : null}

      {showAnswer ?
        <ShowAnswer
          isCorrect={false}
          correctGuesses={countryData.nativeName}
          goToNextCountry={goToNextCountry}
          countryName={countryData.name.common}
          size={countryData.area}
          guesses={guesses}
        />
        : null}
    </>
  );
}

export default Answer;
